import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthService } from '../components/auth.servicice';

@Injectable({
  providedIn: 'root'
})
export class ConsultaPagosService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  getRelacionICA(): Observable<any> {
    const user = this.authService.getValueUser();
    const config = this.authService.getValueConfig();
    const obj: any = {"objeto": user.nroId, "impuesto":"2"}
    let params = new HttpParams();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        params = params.set(key, (obj as any)[key]);
      }
    }
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders, params: params };
    let url = config.urlPago;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.get(`${url}`, httpOptions);
  }

  getRelacionReteICA(): Observable<any> {
    const user = this.authService.getValueUser();
    const config = this.authService.getValueConfig();
    const obj: any = {"objeto": user.nroId, "impuesto":"31"}
    let params = new HttpParams();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        params = params.set(key, (obj as any)[key]);
      }
    }
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders, params: params };
    let url = config.urlPago;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.get(`${url}`, httpOptions);
  }

}
